import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=6b8fc18a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8fc18a')) {
      api.createRecord('6b8fc18a', component.options)
    } else {
      api.reload('6b8fc18a', component.options)
    }
    module.hot.accept("./QuestionPage.vue?vue&type=template&id=6b8fc18a&", function () {
      api.rerender('6b8fc18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/QuestionPage.vue"
export default component.exports